import React from 'react';
import { Link as AnvilLink } from '@servicetitan/design-system';
import { Link as GatsbyLink } from "gatsby";

export const Link = ({href, ...props}) => {
	if (href.startsWith('#') || href.startsWith('http')) return <AnvilLink color="primary" href={href} {...props} />
	return <GatsbyLink {...props} className="Link Link--blue" to={href}/>
}
